import { render, staticRenderFns } from "./docash.vue?vue&type=template&id=b29247d4"
import script from "./docash.vue?vue&type=script&lang=js"
export * from "./docash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports